import {
    CardHeader,
    CardContent,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell, Grid, 
} from "@mui/material";
import React from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import {useDispatch, useSelector} from "react-redux";
import {ChangePassword} from "../Modals/ChangePassword";
import {setModal} from "../../../../Common/App";
import {FormCard} from "../../../../../Components";

export const SecurityPanel = () => {

    const dispatch = useDispatch();
    const auth = useSelector((store) => store.auth);

    const handleEditPassword = () => {
        dispatch(setModal({component: <ChangePassword />, open: true}));
    }

    return (
        <Grid container spacing={4} elevated={3}>
            <Grid item xs={12}>
                <FormCard>
                    <CardHeader
                        title={"Security"}
                    />
                    <CardContent>
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Email</TableCell>
                                        <TableCell>{auth.user?.email}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell>Password</TableCell>
                                        <TableCell>******</TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                color="primary"
                                                sx={{ width: 30, height: 30 }}
                                                onClick={() => handleEditPassword()}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </FormCard>
            </Grid>
        </Grid>
    )
}
